import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

// Clon de SwitchCampaignPage/campaign-context para la fuente tuvocación:
//  - endpoint /api/tuvocacion/campaign (proxy REST)
//  - autorización por token firmado (org+año+SKU, lo verifica tuvocación)
//  - JSON plano del worker; cada resp.data sigue siendo JSON string y el
//    filtro ?grades= sigue siendo client-side (grade = nombre del curso).

const INITIAL_VALUES = {};

const DataContext = createContext(INITIAL_VALUES);

const isJsonValue = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const DataProvider = props => {
  const { children, token, initial, grades } = props;
  const [state, setState] = useState(initial || INITIAL_VALUES);
  const [campaign, setCampaign] = useState(null);
  const [responses, setResponses] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRespData = async () => {
      try {
        const { data } = await axios.get('/api/tuvocacion/campaign', {
          params: { token }
        });
        const campaignData = data.campaign;
        if (campaignData.participants) {
          campaignData.participants = isJsonValue(campaignData.participants)
            ? JSON.parse(campaignData.participants)
            : campaignData.participants;
        }
        if (campaignData.metadata) {
          campaignData.metadata = isJsonValue(campaignData.metadata)
            ? JSON.parse(campaignData.metadata)
            : campaignData.metadata;
        }
        const finishedResponses = data.responses.filter(resp => resp.submitted);
        const campaignResponses = finishedResponses.map(resp => {
          return {
            ...resp,
            data:
              typeof resp.data === 'string' ? JSON.parse(resp.data) : resp.data
          };
        });
        const gradeFilters = grades || [];
        const filteredGradeResponses = campaignResponses.filter(resp => {
          if (gradeFilters.length === 0) return true;
          const respGrade = resp.data?.grade;
          return gradeFilters.includes(respGrade);
        });

        await setCampaign(campaignData);
        await setResponses(filteredGradeResponses);
      } catch (err) {
        console.log(err);
        await setCampaign(null);
      }
      await setLoading(false);
    };
    getRespData();
  }, [token]);

  return (
    <DataContext.Provider
      value={{
        ...state,
        updateContext: setState,
        campaign,
        responses,
        grades,
        isLoading: loading
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const DataConsumer = DataContext.Consumer;
export const useDataContext = () => useContext(DataContext);
